/**
 * The HTML class property name
 * @type {String}
 */
const HTML_CLASS_ATTRIBUTE = 'class';

/**
 * The HTML style property name
 * @type {String}
 */
const HTML_STYLE_ATTRIBUTE = 'style';

module.exports = {
    HTML_STYLE_ATTRIBUTE,
    HTML_CLASS_ATTRIBUTE
};
